// The "IMPORT FILE" of the fabrication orders tab opens the connector screen only when the order list is the general
// one (`allFoMode`) and Sun says the connector is on. Strict `=== true`: null, undefined or a missing field mean classic.
export const shouldUseImportConnector = ({ allFoMode, frontendConfig }) =>
  Boolean(allFoMode) && frontendConfig?.fabricationOrderImportConnectorEnabled === true
